var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartyPopper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.58285 13.0977L3.00085 25.9996L15.9028 21.4297",
    stroke: "#292829",
    strokeWidth: 2.41158,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99878 3.75H5.01211",
    stroke: "#292829",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4988 10.0012H27.5121",
    stroke: "#292829",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 2.50122H18.7633",
    stroke: "#292829",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 23H27.5133",
    stroke: "#292829",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5012 2.50122L24.7012 3.43872C23.9042 3.70421 23.2241 4.23827 22.7773 4.94963C22.3304 5.66098 22.1444 6.50546 22.2512 7.33872C22.3762 8.41372 21.5387 9.37622 20.4387 9.37622H19.9637C18.8887 9.37622 17.9637 10.1262 17.7637 11.1762L17.5012 12.5012",
    stroke: "#292829",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5012 16.2511L26.4762 15.8386C25.4012 15.4136 24.2012 16.0886 24.0012 17.2261C23.8637 18.1011 23.1012 18.7511 22.2137 18.7511H21.2512",
    stroke: "#292829",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 2.50122L14.1625 3.52622C14.5875 4.60122 13.9125 5.80122 12.775 6.00122C11.9 6.12622 11.25 6.90122 11.25 7.78872V8.75122",
    stroke: "#292829",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8517 15.1476C16.1789 17.4747 17.2641 20.1757 16.2633 21.1765C15.2625 22.1773 12.5615 21.0921 10.2344 18.7649C7.90719 16.4378 6.82198 13.7368 7.82278 12.736C8.82359 11.7352 11.5246 12.8204 13.8517 15.1476Z",
    stroke: "#292829",
    strokeWidth: 2.41158,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartyPopper);
export default __webpack_public_path__ + "static/media/party-popper.64e2af8cf42c7b2f1a2cf9f23b916add.svg";
export { ForwardRef as ReactComponent };